var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9545 6.81818V22.5C12.9545 25.5136 10.5136 27.9545 7.5 27.9545C4.48636 27.9545 2.04545 25.5136 2.04545 22.5V5.45455C2.04545 3.57273 3.57273 2.04545 5.45455 2.04545C7.33636 2.04545 8.86364 3.57273 8.86364 5.45455V19.7727C8.86364 20.5227 8.25 21.1364 7.5 21.1364C6.75 21.1364 6.13636 20.5227 6.13636 19.7727V6.81818H4.09091V19.7727C4.09091 21.6545 5.61818 23.1818 7.5 23.1818C9.38182 23.1818 10.9091 21.6545 10.9091 19.7727V5.45455C10.9091 2.44091 8.46818 0 5.45455 0C2.44091 0 0 2.44091 0 5.45455V22.5C0 26.6455 3.35455 30 7.5 30C11.6455 30 15 26.6455 15 22.5V6.81818H12.9545Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnexo);
export default __webpack_public_path__ + "static/media/anexo.0347e202ee373fa46ab39c2f28260332.svg";
export { ForwardRef as ReactComponent };